import React, {useState} from 'react';
import {Button, Form} from "react-bootstrap";

/**
 * Jeden krok ekranu zgód: dokument przewijany razem ze stroną i pasek z checkboxem oraz
 * przyciskami przyklejony do dołu ekranu. Stan checkboxa jest lokalny, więc każde wejście
 * w krok zaczyna od pustego pola.
 */
const ConsentStep = ({step, total, title, checkboxLabel, nextLabel, onNext, onBack, onLogout, children}) => {
  const [checked, setChecked] = useState(false);

  return <div className="consent-step">
    <p className="consent-step-label">Krok {step} z {total}: {title}</p>
    <div className="legal-document">
      {children}
    </div>
    <div className="consent-actions">
      <Form.Check custom type="checkbox" id="consentAccepted" label={checkboxLabel}
                  checked={checked} onChange={(e) => setChecked(e.target.checked)}/>
      <div className="consent-buttons">
        <Button variant="outline-secondary" type="button" onClick={onLogout}>Wyloguj</Button>
        {onBack && <Button variant="outline-secondary" type="button" onClick={onBack}>Wstecz</Button>}
        <Button variant="primary" type="button" disabled={!checked} onClick={onNext}>{nextLabel}</Button>
      </div>
    </div>
  </div>;
}

export default ConsentStep;
